import chartTitles from './defaultTitle';
import _ from 'lodash';
import moment from 'moment';

import constant from './constants';
import {
    LIST_CHART,
    GA_CHART_ID,
    AD_PERFORMANCE_CHART_ID,
    DAYPART_COMPILATION_CHART_ID,
    ADVISIT_CHART_ID,
    GEO_CHART_ID,
    KEYWORD_CHART_ID,
    DEFAULT_CAMPAIGN_CHART_IDS,
    PAGE_PATH_CHART_ID,
    DEVICE_CATEGORY_CHART_ID
} from '../../helpers/constant';
import { Status } from '../../state/modules/app/campaign/actions';
import {
    formatTimeWithShortYear,
    calcAvgAdCost,
    convertTimezoneDate,
    getChartDataKey
} from '../../helpers/formatData';
import { getRangeBeforeCampaign } from "components/DatePicker/constants";
import { calAdperformanceRange, defaultAdperformanceRangeValue } from "components/AdsPerformance/util";
import { DEFAULT_TIME_ZONE_KEY } from 'components/TimeZoneSelector/constants';
import { defaultChartSelector } from '../../helpers/defaultInfo';

const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DEFAULT_SELECTED_CAMPAIGN_DATE_RANGE = -1;

export const dayOfWeek = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
const dateFormat = 'MM/DD/YYYY';

export function convertDataChartId6(rawdata) {
    //replace rawdata
    const data = {
        "title": chartTitles["6"].title,
        "data": [...chartTitles["6"].legends, ...rawdata.data]
    };
    const tableData = [];
    const selected = [];
    const chartData = {};
    const sortedData = _.orderBy(rawdata.data, [0]);
    sortedData.forEach(item => {
        const id = item[constant.TYPE];
        const type = item[constant.TYPE];
        const adsaired = item[constant.ADAIRED];
        const visit = item[constant.VISITS];
        const visitad = item[constant.VISITAD];
        tableData.push({ id, type, adsaired, visit, visitad });
        chartData[id] = [type, visitad];
        if (visitad > 0) {
            selected.push(id);
        }
    });
    data.data = [["Type", "Ads", "Visits", "Visits/Ads"], ...sortedData];
    return {
        ...data,
        tableData,
        selected,
        chartData
    };
}

export function convertDataChartId7(rawdata) {
    //replace rawdata
    const data = {
        "title": chartTitles["7"].title,
        "data": [...chartTitles["7"].legends, ...rawdata.data]
    };
    const tableData = [];
    const selected = [];
    const chartData = {};

    const sortedData = _.orderBy(rawdata.data, [0]);
    sortedData.forEach(item => {
        const id = item[constant.STATION];
        const station = item[constant.STATION];
        const adsaired = item[constant.ADAIRED];
        const visit = item[constant.VISITS] || 0;
        const visitad = item[constant.VISITAD] || 0;
        const stationId = item[constant.STATION_ID] || 0;
        tableData.push({ id, stationId, station, adsaired, visit, visitad });
        chartData[id] = [station, visitad];
        if (visitad > 0) {
            selected.push(id);
        }
    });
    data.data = [["Stations", "Ads", "Visits", "Visits/Ads"], ...sortedData];
    return {
        ...data,
        tableData,
        selected,
        chartData
    };
}

export function createRootData(rawdata) {
    let _key = Math.floor(Math.random() * 10000) + 1;
    const rootdata = {
        dataTable: {
            "title": "Ad Visits by Creative",
            data: [],
            selected: []
        },
        dataPie: {
            "title": "Visits by Creative",
            data: {}
        },
        dataColumn: {
            "title": "Ad Visits by Creative Duration",
            data: {}
        }
    };
    const dataFromServer = rawdata.data || [];
    if (dataFromServer.length > 0) {
        const selected = [];
        const arrTable = [];
        const pieWithId = {};
        const columnWithId = {};
        for (let i = 0; i < dataFromServer.length; i++) {
            let id = _key.toString();
            const creativename = !_.isNil(dataFromServer[i].creative_name)
                ? dataFromServer[i].creative_name : "N/A";

            const source = !_.isNil(dataFromServer[i].type_name)
                ? dataFromServer[i].type_name : "N/A";

            const duration = !_.isNil(dataFromServer[i].creative_duration)
                ? dataFromServer[i].creative_duration : "N/A";

            const station = !_.isNil(dataFromServer[i].station_name)
                ? dataFromServer[i].station_name : "N/A";

            const visit = !_.isNil(dataFromServer[i].visits)
                ? dataFromServer[i].visits : "N/A";

            const adsaired = !_.isNil(dataFromServer[i].aired)
                ? dataFromServer[i].aired : "N/A";

            const visitad = !_.isNil(dataFromServer[i].visitOfads)
                ? dataFromServer[i].visitOfads : "N/A";
            const type_id = dataFromServer[i].type_id;
            const watchlist_id = dataFromServer[i].watchlist_id;
            arrTable.push({
                id,
                creativename,
                source,
                duration,
                station,
                visit,
                adsaired,
                visitad,
                isShowMore: false,
                type_id,
                watchlist_id
            });
            pieWithId[id] = [creativename, visit];
            if (duration !== "N/A") {
                columnWithId[id] = [duration, visitad, visit, adsaired];
            }
            selected.push(id);
            _key++;
        }
        return {
            ...rootdata,
            dataTable: {
                ...rootdata.dataTable,
                data: arrTable,
                selected: selected
            },
            dataPie: {
                ...rootdata.dataPie,
                data: pieWithId
            },
            dataColumn: {
                ...rootdata.dataColumn,
                data: columnWithId
            }
        };
    }
    return rootdata;
}

/**
* format data from API to format use in chart component
* @param {array} rawData - Data get from API
* @param {array} availableChartIds - list chart ids
* @returns {object}
 */
// TODO: remove this
export function formatChartData(rawData, availableChartIds, campaignSummaryData) {
    const totalAds = _.get(campaignSummaryData, "totalAds", 0); 
    return rawData.map((data, index) => {
        const chartId = parseInt(availableChartIds[index]);
        switch(index) {
            case 0:
                return ({
                    id: chartId,
                    data: convertDataChartId1(data)
                });
            case 8:
                return ({
                    id: chartId,
                    title: LIST_CHART[chartId].chartTitle,
                    data: convertDataForCreativeChart(data.data)
                });    
            case 9:
                return ({
                    id: chartId,
                    data: convertDataForGeoChart(data,chartId, totalAds)
                });
            case 3:
                return ({
                    id: chartId,
                    data: convertDataForDaypartCompilationChart(data)
                });
            case 6: 
                return ({
                    id: chartId,
                    title: LIST_CHART[chartId].chartTitle,
                    data: data.data
                })    
            default:
                return({
                    id: chartId,
                    title: LIST_CHART[chartId].chartTitle,
                    data: data.data
                })        
        }
    });
}

export function removeYear(dateString) {
    return dateString.replace(/^(\d{1,2}\/\d{1,2})\/\d{1,4}$/, '$1');
}

export function convertDataByHourChart4(data) {
    const formattedData = data.map(item => {
        const { time, visit, adVisit, ads, user, newAdUsers, avgAdCost, sumAvgAdCost, pricedAds } = item;
        return {
            time: time || "",
            visit: visit || 0,
            adVisit: adVisit || 0,
            ads: ads || 0,
            user: user || 0,
            newAdUsers: newAdUsers || 0,
            avgAdCost,
            sumAvgAdCost,
            pricedAds,
            nonAdVisit: Number((visit - adVisit).toFixed(1)) || 0,
            nonNewAdUsers: Number((user - newAdUsers).toFixed(1)) || 0
        }
    });
    return formattedData;
}

export function sortDataByDateChart(dataByDate) {
    return _.isArray(dataByDate) && dataByDate.sort((before, after) => (new Date(before.time) - new Date(after.time)))
}

export function fillMissingDataChart4(sortedData) {
    const startDate = new Date(_.get(sortedData, "[0].time"));
    return _.isArray(sortedData) && sortedData.reduce((accumulator, currentValue) => {
        const currentDate = new Date(_.get(currentValue, "time"));
        while(startDate < currentDate) {
            const time = moment(`${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}`).format(dateFormat);
            accumulator.push({
                time,
                ads: 0,
                visit: 0,
                adVisit: 0,
                user: 0,
                newUser: 0,
                newAdUsers: 0,
            });
            startDate.setDate(startDate.getDate() + 1); //move to next day
        }
        accumulator.push(currentValue);
        startDate.setDate(startDate.getDate() + 1); //move to next day
        return accumulator;
    }, []);
}

export function convertDataWithoutHourChart4(dataByDate, type) {
    let processedData = [];
    switch(type) {
        case "weekly":
            processedData = dataByDate.reduce((accumulator, currentValue) => {
                const { time, user, visit, adVisit, newAdUsers, ads, sumAvgAdCost, pricedAds } = currentValue;
                const cleanTime = removeYear(time);
                const day = (new Date(time)).getDay();
                const shortenYear = formatTimeWithShortYear(time);
                if (day === 0 || accumulator.length === 0) {
                    accumulator.push({
                        time: `${cleanTime} - ${cleanTime}`,
                        timeWithYear: `${shortenYear} - ${shortenYear}`,
                        user,
                        visit,
                        adVisit,
                        newAdUsers,
                        ads,
                        sumAvgAdCost,
                        pricedAds
                    })
                } else {
                    const groupingValue = accumulator[accumulator.length - 1];
                    groupingValue.time = groupingValue.time.replace(/^(.+ - ).+$/, `$1${cleanTime}`);
                    groupingValue.timeWithYear = groupingValue.timeWithYear.replace(/^(.+ - ).+$/, `$1${shortenYear}`);
                    groupingValue.user += user;
                    groupingValue.visit += visit;
                    groupingValue.adVisit += adVisit;
                    groupingValue.newAdUsers += newAdUsers;
                    groupingValue.ads += ads;
                    groupingValue.sumAvgAdCost = sumAvgAdCost !== null ? groupingValue.sumAvgAdCost + sumAvgAdCost : groupingValue.sumAvgAdCost;
                    groupingValue.pricedAds += pricedAds;
                }
                return accumulator;
            }, []);
            break;
        case "monthly":
            processedData = dataByDate.reduce((accumulator, currentValue) => {
                const { user, visit, adVisit, newAdUsers, ads, sumAvgAdCost, pricedAds } = currentValue;
                const currentDate = new Date(_.get(currentValue, "time"));
                const month = currentDate.getMonth();
                const year = currentDate.getFullYear();
                const time = `${monthNames[month]} ${year}` || "";
                const currentTime = _.get(accumulator, [accumulator.length - 1, "time"]) || "";

                if(currentTime !== time || accumulator.length === 0) {
                    accumulator.push({
                        time,
                        user,
                        visit,
                        adVisit,
                        newAdUsers,
                        ads,
                        sumAvgAdCost,
                        pricedAds
                    })
                } else {
                    const groupingValue = accumulator[accumulator.length - 1];
                    groupingValue.ads += ads;
                    groupingValue.user += user;
                    groupingValue.visit += visit;
                    groupingValue.adVisit += adVisit;
                    groupingValue.newAdUsers += newAdUsers;
                    groupingValue.sumAvgAdCost = sumAvgAdCost !== null ? groupingValue.sumAvgAdCost + sumAvgAdCost : groupingValue.sumAvgAdCost;
                    groupingValue.pricedAds += pricedAds;
                }
                return accumulator;
            }, []);
            break;
        default:
            processedData = dataByDate.map(item => {
                const { time, ads, user, visit, adVisit, newAdUsers, sumAvgAdCost, pricedAds } = item;
                return {
                    time: removeYear(time) || "",
                    timeWithYear: time || "",
                    ads: ads || 0,
                    user: user || 0,
                    visit: visit || 0,
                    adVisit: adVisit || 0,
                    newAdUsers: newAdUsers || 0,
                    sumAvgAdCost,
                    pricedAds
            }
        });
    }
    const formattedData = processedData.map(item => {
        const { time, timeWithYear, user, visit, adVisit, newAdUsers, ads, sumAvgAdCost, pricedAds } = item;
        const avgAdCost = pricedAds > 0 && sumAvgAdCost !== null ? Number(sumAvgAdCost/pricedAds) : null;
        return {
            time,
            timeWithYear,
            user,
            visit,
            adVisit,
            newAdUsers,
            ads,
            avgAdCost,
            sumAvgAdCost,
            nonAdVisit: Number((visit - adVisit).toFixed(1)),
            nonNewAdUsers: Number((user - newAdUsers).toFixed(1)),
            pricedAds
        }
    });
    return formattedData;
}

export function convertDataForDaypartCompilationChart(response) {
    const dataByDate = _.get(response, "data.byDate", []);
    const sortedDataByDate = sortDataByDateChart(dataByDate) || [];
    const fullDailyData = fillMissingDataChart4(sortedDataByDate) || [];
    const dataByHour = _.get(response, "data.byHour", []);
    const data = {
        hourly: convertDataByHourChart4(dataByHour),
        daily: convertDataWithoutHourChart4(fullDailyData),
        weekly: convertDataWithoutHourChart4(fullDailyData, "weekly"),
        monthly: convertDataWithoutHourChart4(fullDailyData, "monthly"),
        byDayPart: convertDataByDayPart(dataByHour),
        byDayOfWeek: convertDataByDayOfWeek(fullDailyData)
    }
    return data;
}

export function convertDataByDayPart(dataByHour) {
    const listOfHours = [
        '12am', '1am', '2am', '3am', '4am', '5am', '6am', '7am', '8am', '9am', '10am', '11am', 
        '12pm', '1pm', '2pm', '3pm', '4pm', '5pm', '6pm', '7pm', '8pm', '9pm', '10pm', '11pm' 
    ];
    const data = dataByHour.reduce((accumulator, store) => {
        const hourIdx = listOfHours.indexOf(store.time);
        const { ads, adVisit, visit, user, newAdUsers, pricedAds, sumAvgAdCost } = store;
        const morning = accumulator[0];
        const midday = accumulator[1];
        const afternoon = accumulator[2];
        const evening = accumulator[3];
        const overnight = accumulator[4];
        if (hourIdx < 6) {
            overnight.visit += visit;
            overnight.user += user;
            overnight.newAdUsers += newAdUsers;
            overnight.ads += ads;
            overnight.adVisit += adVisit;
            overnight.pricedAds += pricedAds;
            overnight.sumAvgAdCost = sumAvgAdCost !== null ? overnight.sumAvgAdCost + sumAvgAdCost : overnight.sumAvgAdCost;
        } else if (hourIdx < 10) {
            morning.visit += visit;
            morning.user += user;
            morning.newAdUsers += newAdUsers;
            morning.ads += ads;
            morning.adVisit += adVisit;
            morning.pricedAds += pricedAds;
            morning.sumAvgAdCost = sumAvgAdCost !== null ? morning.sumAvgAdCost + sumAvgAdCost : morning.sumAvgAdCost;
        } else if (hourIdx < 15) {
            midday.visit += visit;
            midday.user += user;
            midday.newAdUsers += newAdUsers;
            midday.ads += ads;
            midday.adVisit += adVisit;
            midday.pricedAds += pricedAds;
            midday.sumAvgAdCost = sumAvgAdCost !== null ? midday.sumAvgAdCost + sumAvgAdCost : midday.sumAvgAdCost;
        } else if (hourIdx < 19) {
            afternoon.visit += visit;
            afternoon.user += user;
            afternoon.newAdUsers += newAdUsers;
            afternoon.ads += ads;
            afternoon.adVisit += adVisit;
            afternoon.pricedAds += pricedAds;
            afternoon.sumAvgAdCost = sumAvgAdCost !== null ? afternoon.sumAvgAdCost + sumAvgAdCost : afternoon.sumAvgAdCost;
        } else if (hourIdx < 24) {
            evening.visit += visit;
            evening.user += user;
            evening.newAdUsers += newAdUsers;
            evening.ads += ads;
            evening.adVisit += adVisit;
            evening.pricedAds += pricedAds;
            evening.sumAvgAdCost = sumAvgAdCost !== null ? evening.sumAvgAdCost + sumAvgAdCost : evening.sumAvgAdCost;
        }
        return accumulator;
    }, [
        { time: 'Morning (6am-10am)', visit: 0, user: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, ads: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: 'Midday (10am-3pm)', visit: 0, user: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, ads: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: 'Afternoon (3pm-7pm)', visit: 0, user: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, ads: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: 'Evening (7pm-12am)', visit: 0, user: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, ads: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: 'Overnight (12am-6am)', visit: 0, user: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, ads: 0, sumAvgAdCost: 0, pricedAds: 0 }
    ]);

    const formattedData = data.map(item => {
        const { time, visit, user, newAdUsers, adVisit, ads, sumAvgAdCost, pricedAds } = item;
        const avgAdCost = sumAvgAdCost !== null && pricedAds > 0 ?  Number(sumAvgAdCost / pricedAds) : null;
        return {
            time,
            visit,
            user,
            newAdUsers,
            adVisit,
            ads,
            avgAdCost,
            sumAvgAdCost,
            nonAdVisit: Number((visit - adVisit).toFixed(1)),
            nonNewAdUsers: Number((user - newAdUsers).toFixed(1)),
            pricedAds
        }
    });
    return formattedData;
}

export function convertDataByDayOfWeek(dataByDate) {
    const processedData = dataByDate.reduce((acc, item) => {
        const dayIndex = moment(item.time, dateFormat).day();
        const { ads, visit, user, newAdUsers, adVisit, sumAvgAdCost, pricedAds } = item;
        acc[dayIndex].user += user;
        acc[dayIndex].visit += visit;
        acc[dayIndex].ads += ads;
        acc[dayIndex].newAdUsers += newAdUsers;
        acc[dayIndex].adVisit += adVisit;
        acc[dayIndex].pricedAds += pricedAds;
        acc[dayIndex].sumAvgAdCost = sumAvgAdCost !== null ? acc[dayIndex].sumAvgAdCost + sumAvgAdCost : acc[dayIndex].sumAvgAdCost;
        return acc;
    },[
        { time: dayOfWeek[0], user: 0, visit: 0, ads: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: dayOfWeek[1], user: 0, visit: 0, ads: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: dayOfWeek[2], user: 0, visit: 0, ads: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: dayOfWeek[3], user: 0, visit: 0, ads: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: dayOfWeek[4], user: 0, visit: 0, ads: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: dayOfWeek[5], user: 0, visit: 0, ads: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, sumAvgAdCost: 0, pricedAds: 0 },
        { time: dayOfWeek[6], user: 0, visit: 0, ads: 0, newAdUsers: 0, adVisit: 0, nonAdVisit: 0, nonNewAdUsers: 0, sumAvgAdCost: 0, pricedAds: 0 }
    ]);

    const formattedData = processedData.map(item => {
        const { time, user, visit, adVisit, newAdUsers, ads, sumAvgAdCost, pricedAds } = item;
        const avgAdCost = sumAvgAdCost !== null && pricedAds > 0 ?  Number(sumAvgAdCost / pricedAds) : null;
        return {
            time,
            user,
            visit,
            adVisit: Number(adVisit.toFixed(1)),
            newAdUsers,
            ads,
            avgAdCost,
            sumAvgAdCost,
            nonAdVisit: Number((visit - adVisit).toFixed(1)),
            nonNewAdUsers: Number((user - newAdUsers).toFixed(1)),
            pricedAds
        }
    });
    return formattedData;
}

export function convertDataChartId1(response) {
    const primaryDataByDate = _.get(response, "primaryData.byDate", []);
    const secondaryDataByDate = _.get(response, "secondaryData.byDate", []);
    const dataToolTipByDate = _.get(response, "dataTooltip.byDate", []);

    const sortedPrimaryData = sortDataByDateChart(primaryDataByDate) || [];
    const sortedSecondaryData = sortDataByDateChart(secondaryDataByDate) || [];
    const sortedDataToolTip = sortDataByDateChart(dataToolTipByDate) || [];
    
    const fullPrimaryData = fillMissingDataChart1(sortedPrimaryData) || [];
    const fullSecondaryData = fillMissingDataChart1(sortedSecondaryData) || [];
    const fullDataToolTip = fillMissingDataChart1(sortedDataToolTip) || [];
    
    const primaryDataByHour = _.get(response, "primaryData.byHour", []);
    const secondaryDataByHour = _.get(response, "secondaryData.byHour", []);
    const dataToolTipByHour = _.get(response, "dataTooltip.byHour", []);

    const dataByDate = {
        primaryData: fullPrimaryData,
        secondaryData: fullSecondaryData,
        dataToolTip: fullDataToolTip
    }

    const dataByHour = {
        primaryData: primaryDataByHour,
        secondaryData: secondaryDataByHour,
        dataToolTip: dataToolTipByHour
    }

    const dataKeys = ["user", "visit", "adUser", "adVisit", "avgAdCost", "ads", "newAdUsers"]

    const chartDataId1 = {}

    dataKeys.forEach(key => {
      chartDataId1[key] = {
        hourly: convertDataByTypeForWebAnalyticsChart(dataByHour, key),
        daily: convertDataWithoutHourChart1(dataByDate, key),
        weekly: convertDataWithoutHourChart1(dataByDate, key, "weekly"),
        monthly: convertDataWithoutHourChart1(dataByDate, key, "monthly")
      }
    });
 
    return chartDataId1;
}

//TODO we might merged this function convertDataByTypeForWebAnalyticsChart and convertDataWithoutHourChart1
export function convertDataByTypeForWebAnalyticsChart(dataByHour, metric) {
    let tooltipMetric;
    let isAvgCost = false;
    switch(metric) {
        case "user":{
            tooltipMetric = "hourlyUsersPercentageChange";
            break;
        }
        case "adUser":{
            tooltipMetric = "hourlyAdUsersPercentageChange";
            break;
        }
        case "adVisit":{
            tooltipMetric = "hourlyAdVisitsPercentageChange";
            break;
        }
        case "ads":{
            tooltipMetric = "";
            break;
        }
        case "avgAdCost":{
            tooltipMetric = "";
            isAvgCost = true;
            break;
        }
        default: {
            tooltipMetric = "visitByHourPecent";
        }
        
    }

    const { primaryData, secondaryData } = dataByHour;

    const result = primaryData.map((datum, index) => {
            let firstValue =
                metric === 'avgAdCost' ? _.get(primaryData, [index, metric]) :
                _.get(primaryData, [index, metric]) || 0;
            const secondValue = _.get(secondaryData, [index, metric], 0) || 0;
            const change = secondValue === 0 ? 0 : Math.round(((firstValue-secondValue)*100/secondValue));
            const timeComparison = _.get(secondaryData, [index, 'time'], '');
            if(isAvgCost){
                // const totalAds = _.get(primaryData, [index, 'ads'], 0) || 0;
                const pricedAds = _.get(datum, 'pricedAds', 0);
                firstValue = calcAvgAdCost(firstValue, pricedAds);
            }
            return {
                time: datum.time || "",
                firstValue: firstValue,
                secondValue: secondValue,
                change: change || 0,
                timeComparison: timeComparison
            }
        }
    );
    return result;
}

export function convertDataWithoutHourChart1(dataByDate, metric, type) {
    const { primaryData, secondaryData, dataToolTip } = dataByDate;
    let isAvgCost = false;
    let tooltipMetric;
    switch(metric) {
        case "user":{
            tooltipMetric = "dailyUsersPercentageChange";
            break;
        }
        case "adUser":{
            tooltipMetric = "dailyAdUsersPercentageChange";
            break;
        }
        case "adVisit":{
            tooltipMetric = "dailyAdVisitsPercentageChange";
            break;
        }
        case "ads":{
            tooltipMetric = "";
            break;
        }
        case "avgAdCost":{
            isAvgCost = true;
            tooltipMetric = "";
            break;
        }
        default: {
            tooltipMetric = "dailyVisitsPercentageChange";
        }        
    }

    switch(type) {
        case "weekly": {
            const weeklyData = primaryData.reduce((accumulator, currentValue, index) => {
                const currentTime = _.get(currentValue, "time");
                const firstValue =
                    metric === 'avgAdCost' ? _.get(primaryData, [index, metric]) :
                    _.get(primaryData, [index, metric]) || 0;
                const secondValue = _.get(secondaryData, [index, metric], 0) || 0;
                const change = _.get(dataToolTip, [index, tooltipMetric], 0) || 0;
                const totalAds = _.get(currentValue, 'ads', 0);
                const pricedAds = _.get(currentValue, 'pricedAds', 0);
                const cleanTime = formatTimeWithShortYear(currentTime);
                const day = (new Date(currentTime)).getDay();
                const timeComparison = _.get(secondaryData, [index, 'time'], '');
                const cleanTimeComparison = formatTimeWithShortYear(timeComparison);
                
                if (day === 0 || accumulator.length === 0) {
                    accumulator.push({
                        time: `${cleanTime} - ${cleanTime}`,
                        firstValue,
                        secondValue,
                        change,
                        totalAds,
                        pricedAds,
                        timeComparison: `${cleanTimeComparison} - ${cleanTimeComparison}`,
                    })
                } else {
                    const groupingValue = accumulator[accumulator.length - 1];
                    if (metric !== 'avgAdCost' || metric === 'avgAdCost' && firstValue !== null) {
                        groupingValue.firstValue += firstValue;
                    }
                    groupingValue.secondValue += secondValue;
                    groupingValue.time = groupingValue.time.replace(/^(.+ - ).+$/, `$1${cleanTime}`);
                    groupingValue.totalAds += totalAds;
                    groupingValue.pricedAds += pricedAds;
                    groupingValue.timeComparison = groupingValue.timeComparison.replace(/^(.+ - ).+$/, `$1${cleanTimeComparison}`);
                }
                return accumulator;
            }, []);
            weeklyData.forEach(item => {
                const { firstValue, secondValue, pricedAds } = item;
                item.change = !secondValue ? 0 : Math.round(((firstValue-secondValue)*100/secondValue));
                if(isAvgCost){
                    item.firstValue = calcAvgAdCost(firstValue, pricedAds);
                }
                delete item.totalAds
            })
            return weeklyData;
        }
            
        case "monthly": {
            const monthlyData =  primaryData.reduce((accumulator, currentValue, index) => {
                const currentDate = new Date(_.get(currentValue, "time"));
                const month = currentDate.getMonth();
                const year = currentDate.getFullYear();
                const time = `${monthNames[month]} ${year}`;

                const currentTime = _.get(accumulator, [accumulator.length - 1, "time"]);                
                const firstValue =
                    metric === 'avgAdCost' ? _.get(primaryData, [index, metric]) :
                    _.get(primaryData, [index, metric]) || 0;
                const secondValue = _.get(secondaryData, [index, metric], 0) || 0;
                const change = _.get(dataToolTip, [index, tooltipMetric], 0) || 0;
                const totalAds = _.get(primaryData, [index, 'ads'], 0) || 0;
                const pricedAds = _.get(currentValue, 'pricedAds', 0);

                const comparisonDate = new Date(_.get(secondaryData, [index, 'time'], ''));
                const comparisonMonth = comparisonDate.getMonth();
                const comparisonYear = comparisonDate.getFullYear();
                const timeComparison = `${monthNames[comparisonMonth]} ${comparisonYear}`;

                if(currentTime !== time || accumulator.length === 0) {
                    accumulator.push({
                        time,
                        firstValue,
                        secondValue,
                        change,
                        totalAds,
                        pricedAds,
                        timeComparison
                    })
                } else {
                    const groupingValue = accumulator[accumulator.length - 1];
                    if (metric !== 'avgAdCost' || metric === 'avgAdCost' && firstValue !== null) {
                        groupingValue.firstValue += firstValue;
                    }
                    groupingValue.secondValue += secondValue;
                    groupingValue.totalAds += totalAds;
                    groupingValue.pricedAds += pricedAds;
                }
                return accumulator;
            }, []);
            monthlyData.forEach(item => {
                const { firstValue, secondValue, pricedAds } = item;
                item.change = !secondValue ? 0 : Math.round(((firstValue-secondValue)*100/secondValue));

                if(isAvgCost){
                    item.firstValue = calcAvgAdCost(firstValue, pricedAds);
                }
                delete item.totalAds
            })
            return monthlyData;
        }            
        default:
            return primaryData.map((item, index) => {
                let firstValue  =
                    metric === 'avgAdCost' ? _.get(primaryData, [index, metric]) :
                    _.get(primaryData, [index, metric]) || 0;
                const secondValue = _.get(secondaryData, [index, metric], 0) || 0;
                const change = secondValue === 0 ? 0 : Math.round(((firstValue-secondValue)*100/secondValue));
                if(isAvgCost){
                    // const totalAds = _.get(primaryData, [index, 'ads'], 0) || 0;
                    const pricedAds = _.get(item, 'pricedAds', 0);
                    firstValue = calcAvgAdCost(firstValue, pricedAds);
                }
                const timeComparison = _.get(secondaryData, [index, 'time'], '');

                return{
                    time: item.time || "",
                    firstValue: firstValue,
                    secondValue: secondValue,
                    change: change || 0,
                    timeComparison: timeComparison
                }
            }
        );
    }
}

export function fillMissingDataChart1(sortedData) {
    const startDate = new Date(_.get(sortedData, "[0].time"));
    return _.isArray(sortedData) && sortedData.reduce((accumulator, currentValue) => {
        const currentDate = new Date(_.get(currentValue, "time"));
        while(startDate < currentDate) {
            const time = moment(`${startDate.getMonth() + 1}/${startDate.getDate()}/${startDate.getFullYear()}`).format(dateFormat);
            accumulator.push({
                time,
                firstValue: 0,
                secondValue: 0,
                change: 0
            });
            startDate.setDate(startDate.getDate() + 1); //move to next day
        }
        accumulator.push(currentValue);
        startDate.setDate(startDate.getDate() + 1); //move to next day
        return accumulator;
    }, []);
}

export function formatGeoData(location = {}) {
    const locationData = {...location};
    const {
        visits,
        new_users: newUser,
        children,
        totalCost,
        pricedAds
    } = locationData;
    locationData.visits = visits && parseFloat(visits.toFixed(1));
    locationData.new_users = newUser && parseFloat(newUser.toFixed(1));
    locationData.avgAdCost = (totalCost !== null && pricedAds > 0) ? parseFloat((totalCost/pricedAds).toFixed(1)) : null; 
    const childrenData = children && children.map(child => {
        const childData = formatGeoData(child);
        return childData;
    })
    locationData.children = childrenData;
    return locationData;
}

export function convertDataForGeoChart(rawData, chartId, totalAds) {
    const dataGeo = _.get(rawData, "data", {});
    const childrenDataGeo = [];
    for ( let id in dataGeo) {
        const location = dataGeo[id];
        const locationData = formatGeoData(location);
        childrenDataGeo.push(locationData);
    }
    const updateDataGeo = {
        children: childrenDataGeo,
        ads: totalAds
    }
    const selectedChildren = _.get(rawData, "children", []);
    return {
        title:LIST_CHART[chartId].chartTitle,
        dataDisplay: [updateDataGeo],
        selected: selectedChildren.map(item => item.criterial_id),
    }
}

export function convertDataForCreativeChart(rawData){
    return rawData.map((item) => {
        const totalCost  = _.get(item,'sumAvgAdCost');
        const avgAdCost = _.get(item,'avgAdCost');
        return {
            ...item,
            avgAdCost,
            totalCost
        }
    })
}

export function prepGeoData(geoData = {}) {
    return Object.values(geoData).reduce((accum, currentData) => {
        const { criterial_id, visits, new_users, ads, pricedAds, totalAdCost, hasChildren } = currentData;
        if (currentData) {
          const visitsOfAds = ads? visits / ads : 0;
          const avgAdCost = pricedAds? parseFloat( totalAdCost / pricedAds ) : 'N/A';
          const roundedNewUsers = Math.round(new_users);
          accum[criterial_id] = {
              ...currentData,
              visitsOfAds,
              avgAdCost,
              visits,
              new_users: roundedNewUsers
          };
          if (!hasChildren || criterial_id == 0) {
            accum[criterial_id].status = Status.LOADED;
          }
        }
        return accum;
      }, {});
}

export function getFormatedSummaryCampaignData(data) {    
    const totalVisits = _.get(data, 'totalVisit', 0);
    const totalVisitWithAds = _.get(data, 'totalVisitWithAds', 0);
    const totalAds = _.get(data, "totalAds", 0); 
    const adVisits = _.get(data, "adVisit", null);
    const roundedAdVisit = Math.round(adVisits);
    const newAdUsers = _.get(data, "newUsers", null);
    const totalAdUsers = _.get(data, "totalAdUsers", null);
    const avgAdCost = _.get(data, "avgAdCost", null);
    const geoType = _.get(data, 'geoType', 'location');
    const visitDiff = totalVisitWithAds - roundedAdVisit;
    const trafficFromAds = (totalVisitWithAds && visitDiff) ? `${(roundedAdVisit / visitDiff * 100).toFixed(1)}%` : 0;
    const totalNewUsers = _.get(data, 'totalNewUsers');
    const avgIndustryLift = _.get(data, 'avgIndustryLift');
    
    const formatAvgIndustryLift = avgIndustryLift? `${avgIndustryLift.toFixed(1)}%` : avgIndustryLift;

    const dayWithAds = _.get(data, "dayWithAds", 0);
    const visitPerDayWithAds = totalVisitWithAds / dayWithAds;
    const dayWithoutAds = _.get(data, "dayWithoutAds", 0);
    const totalVisitWithoutAds = totalVisits - totalVisitWithAds;
    const visitPerDayWithoutAds = (totalVisitWithoutAds === 0 || dayWithoutAds === 0) ? 0 : (totalVisitWithoutAds) / dayWithoutAds;
    const onAirLift =
      totalVisitWithAds === 0
        ? '0%'
        : `${Math.round(
            ((visitPerDayWithAds - visitPerDayWithoutAds) /
              visitPerDayWithAds) *
              100
          )}%`;
    
    return {
        totalVisits,
        totalVisitWithAds,
        totalAds,
        adVisits: roundedAdVisit,
        newAdUsers,
        totalAdUsers,
        avgAdCost,
        geoType,
        trafficFromAds,
        totalNewUsers,
        avgIndustryLift: formatAvgIndustryLift,
        onAirLift,
    };
};

export function convertDataKeyword(data) {
    return {
        byKeyword: groupDataByKeyword(data)
    }
}

export function convertDeviceCategoryData(data) {
    return data.map(item => {
        const {
            device_category,
            total_visits,
            total_ad_visits,
            total_ads
        } = item;
        return {
            deviceId: device_category,
            deviceType: device_category,
            ads: parseInt(total_ads || 0),
            adVisits: parseFloat(total_ad_visits) || 0,
            totalVisits: parseFloat(total_visits) || 0,
        }
    })
}

export function convertPagePathData(data) {
    return data.map(item => {
        const {
            page_path,
            total_visits,
            total_ad_visits,
            total_ads
        } = item;
        return {
            pagePathId: page_path,
            pagePathType: page_path,
            ads: parseInt(total_ads || 0),
            adVisits: parseFloat(total_ad_visits) || 0,
            totalVisits: parseFloat(total_visits) || 0,
        }
    })
}

export function getCampaignDateInfo(campaign) {
    const timezoneKey = _.get(campaign, 'timezoneSetting.timezoneKey', DEFAULT_TIME_ZONE_KEY);
    const campaignStartDate = _.get(campaign, 'start_date') || _.get(campaign, 'startDate');
    const campaignEndDate = _.get(campaign, 'end_date') ||  _.get(campaign, 'endDate');
    const startMaster = _.get(campaign, 'masterCalendar.selected.start') || campaignStartDate;
    const endMaster = _.get(campaign, 'masterCalendar.selected.end') || campaignEndDate;
    const startDateMaster = convertTimezoneDate(startMaster, timezoneKey, true);
    const endDateMaster = convertTimezoneDate(endMaster, timezoneKey, false);
    const rangeBeforeCampaign = getRangeBeforeCampaign({start: campaignStartDate, end: campaignEndDate});
    const startSecond = _.get(campaign, 'secondCalendar.selected.start') || rangeBeforeCampaign.start;
    const endSecond = _.get(campaign, 'secondCalendar.selected.end') || rangeBeforeCampaign.end;
    const startDateTimeSecondary = convertTimezoneDate(startSecond, timezoneKey, true);
    const endDateTimeSecondary = convertTimezoneDate(endSecond, timezoneKey, false);
    const {
      start: startDefault,
      end: endDefault
    } = calAdperformanceRange(campaignStartDate)[defaultAdperformanceRangeValue];
    const startAdperformance = _.get(campaign, 'adPerformanceCalendar.selected.start', startDefault);
    const endAdperformance = _.get(campaign, 'adPerformanceCalendar.selected.end', endDefault);
    const startDateAdperformance = convertTimezoneDate(startAdperformance,timezoneKey, true);
    const endDateAdperformance = convertTimezoneDate(endAdperformance,timezoneKey, false);
    const rangeSecond = `${startDateTimeSecondary} - ${endDateTimeSecondary}`;
    const rangeAdperormance = `${startDateAdperformance} - ${endDateAdperformance}`;
    const rangeObject = { start: startMaster, end: endMaster, timezone: timezoneKey };
    const isScheduleReport = _.get(campaign, 'isScheduleReport', false);
    const masterCalendar = {
        selected: {
            start: startMaster,
            end: endMaster
        },
        value: isScheduleReport ? DEFAULT_SELECTED_CAMPAIGN_DATE_RANGE : undefined
    };
    
    const firstCalendar = {...masterCalendar};
    const secondCalendar = {
        selected: {
            start: startSecond,
            end: endSecond
        }
    };
    const adPerformanceCalendar = {
        selected: {
            start: startAdperformance,
            end: endAdperformance
        }
    };
    return {
        campaignStartDate,
        campaignEndDate,
        startMaster,
        endMaster,
        startDateMaster,
        endDateMaster,
        startDateTimeSecondary,
        endDateTimeSecondary,
        startDateAdperformance,
        endDateAdperformance,
        rangeSecond,
        rangeAdperormance,
        rangeObject,
        masterCalendar,
        firstCalendar,
        secondCalendar,
        adPerformanceCalendar
    };
}

export function formatAdvertiserData(advertiser) {
    const formatedAdvertiser = advertiser;
    return formatedAdvertiser;
}

export function getFormattedChartData(chartData = [], campaign, chartIds) {
    const currentChartIds = chartIds || DEFAULT_CAMPAIGN_CHART_IDS;
    const { rangeSecond, rangeAdperormance } = getCampaignDateInfo(campaign);
    const formattedChartData = chartData && chartData.reduce((accum, currentData, index) => {
        const currentChartID = parseInt(currentChartIds[index]);
        const clonedData = _.cloneDeep(currentData);
        switch(currentChartID) {
            case GA_CHART_ID:
            {
                const formatGAChartData = convertDataChartId1(clonedData);
                accum[currentChartID] = {
                    [rangeSecond]: {
                        data: {...formatGAChartData}
                    }
                }
                break;
            }
            case AD_PERFORMANCE_CHART_ID:
            {
                accum[currentChartID] = {
                    [rangeAdperormance]: clonedData
                }
                break;
            }
            case DAYPART_COMPILATION_CHART_ID:
            {
                const dayPartChartData = convertDataForDaypartCompilationChart(clonedData);
                accum[currentChartID] = { data: dayPartChartData };
                break;
            }
            case ADVISIT_CHART_ID:
            {
                const creativeChartData = convertDataForCreativeChart(clonedData.data);
                accum[currentChartID] = { data: creativeChartData };
                break;
            }
            case GEO_CHART_ID:
            {
                const data = _.get(clonedData, 'data', {});
                const childData = _.get(clonedData, 'childData', {});
                const formattedData = _.isEmpty(childData) ? prepGeoData(data) : processGeoDataAllLevel(clonedData, childData);
                accum[currentChartID] = {
                    data: formattedData,
                    status: Status.LOADED
                };
                break;
            }
            case KEYWORD_CHART_ID:
            {
                const data = _.get(clonedData, 'data', {});
                const keywordData = convertDataKeyword(data);
                accum[currentChartID] = { data: keywordData };
                break;
            }

            case PAGE_PATH_CHART_ID:
            {
                const data = _.get(clonedData, 'data', {});
                const formattedData = convertPagePathData(data)
                accum[currentChartID] = { data: formattedData };
                break;
            }

            case DEVICE_CATEGORY_CHART_ID:
                {
                    const data = _.get(clonedData, 'data', {});
                    const formattedData = convertDeviceCategoryData(data)
                    accum[currentChartID] = { data: formattedData };
                    break;
                }
            
            default:
            {
                accum[currentChartID] = { data: _.get(clonedData, 'data', []) };
            }
        }
        return accum;
    }, {});
    return formattedChartData;
}

export function getFormattedCampaignData({
    campaign,
    summaryData,
    chartData,
    isAdSourcesEnabled,
    chartSelector = defaultChartSelector
}) {
    const {
        startMaster,
        endMaster,
        startDateMaster,
        endDateMaster,
        masterCalendar,
        firstCalendar,
        secondCalendar,
        adPerformanceCalendar
    } = getCampaignDateInfo(campaign);
    const timezoneKey = _.get(campaign, 'timezoneSetting.timezoneKey', DEFAULT_TIME_ZONE_KEY);
    const range = { start: startMaster, end: endMaster, timezone: timezoneKey };
    const rangeKey = getChartDataKey({ range });
    const selectedAdSources = _.get(summaryData, 'adSources', []);
    const chartKeyWithAdSources = getChartDataKey({ range, selectedAdSources });
    const chartKey = isAdSourcesEnabled ? chartKeyWithAdSources : rangeKey;
    const formattedSummaryData = getFormatedSummaryCampaignData(summaryData);
    const { geoType } = formattedSummaryData;
    const formattedChartData = getFormattedChartData(Object.values(chartData), campaign);
    const formattedCampaignData = {
        ...campaign,
        campaign_name: campaign.campaign_name || campaign.name || campaign.campaignName,
        campaign_id: campaign.campaign_id || campaign.id || campaign.campaignId,
        start_date: campaign.start_date || campaign.startDate,
        end_date: campaign.end_date || campaign.endDate,
        advertiser_id: campaign.advertiser_id || campaign.advertiserId,
        masterCalendar,
        firstCalendar,
        secondCalendar,
        adPerformanceCalendar,
        chartSelector: _.isEmpty(chartSelector) ? defaultChartSelector : chartSelector,
        geoType,
        availableAdSources: {
            [rangeKey]: selectedAdSources
        },
        selectedAdSources: isAdSourcesEnabled ? selectedAdSources : undefined,
        chartData: {
          [chartKey]:{
              ...formattedSummaryData,
              ...formattedChartData,
              startDate: startDateMaster,
              endDate: endDateMaster
          }
        }
    };
    return formattedCampaignData;
};

/**
 * 
 * @param {object} geoChartData: current all geo data 
 * geoChartData = {
 *      2840: {
 *          adVisit: ...,
 *          ads: ...
 *      }
 * }
 * @param {object} childData : child data of the location
 *  childData = {
 *      12345: {
 *          adVisit: ...,
 *          ads: ...
 *      },
 *      12346: {
 *          adVisit: ...,
 *          ads: ...
 *      },
 * }   
 * @param {array} pathIds : location path
 *      pathIds = [2840]
 * @returns {object} location with children data
 * {
 *       2840: {
 *          adVisit: ...,
 *          ads: ...
 *          children: {
 *               12345: {
 *                  adVisit: ...,
 *                  ads: ...
 *              },
 *              12346: {
 *                  adVisit: ...,
 *                  ads: ...
 *              },
 *          }
 *      }
 * }
 */

export function attachGeoChildrenData(geoChartData, childData, pathIds) {
    const newGeoChartData = _.cloneDeep(geoChartData);
    const lastIndex = pathIds.length -1;
    const locationKeys = pathIds.reduce((accum, id, index) => {
      if (index === lastIndex) {
        accum.push(id);
      } else {
        accum.push(id, 'children');
      }
      return accum;
    }, []);
    const targetLocation = _.get(newGeoChartData, ['data', ...locationKeys]);

    if (targetLocation) {
      targetLocation.status = Status.LOADED;
      targetLocation.children = {...childData};
    }
    return newGeoChartData;
}

/**
 * 
 * @param {object} geoData: campaign data world level
 * @param {array} childGeoData: geo data all level except world level
 *  childGeoData: [
        {
            path: [2840],
            key: '2840',
            data: {
                adVisit:...
            } 
        },
        {
            path: [2840, 12345],
            key: '2840-12345,
            data: {
                adVisit:...
            } 
        }
    ]
 * @returns {object} geo data all level
    {
        2840: {
            adVisit: ...
            children: {
                12345: {
                    adVisit: ...
                    children: {...}
                }
            }
        },
        2841: {
            adVisit: ...
        }
    }
 */

export function processGeoDataAllLevel(geoData, childGeoData) {
    const sortChildGeoData = _.orderBy(childGeoData, 'path.length');
    const highLevelGeoData = prepGeoData(geoData.data);
    let chartData = {
        ...geoData,
        data: highLevelGeoData
    };
    sortChildGeoData.forEach(locationData => {
        const {
            path,
            data
        } = locationData;
        const formatedLocationData = prepGeoData(data);
        chartData = attachGeoChildrenData(
            chartData,
            formatedLocationData,
            path
        )
    })
    return _.get(chartData, 'data', {});
}

/**
 * 
 * @param {arr} arr : array of object to sum, object shape:
 * {
 *  visits: num,
 *  newUsers: num,
 *  adVisits: num,
 *  newAdUsers: num
 * }
 * @returns object sum by array data:
 * {
 *  visits: num, //sum from arr
 *  newUsers: num, //sum from arr
 *  adVisits: num, //sum from arr
 *  newAdUsers: num //sum from arr
 * }
 */
export function sumData(arr = []) {
    return arr.reduce((acc, item) => {
        acc.visits += item.visits || 0;
        acc.newUsers += item.newUsers || 0;
        acc.adVisits += item.adVisits || 0;
        acc.newAdUsers += item.newAdUsers || 0;
        return acc;
      }, {
        visits: 0,
        newUsers: 0,
        adVisits: 0,
        newAdUsers: 0,
    });
};

/**
 * 
 * @param {arrayOfObject} data: each object is a keyword data info at a time
 * {
 *  keywordValue: string,
 *  collectedDate: Date object,
 *  visits: num,
 *  newUsers: num,
 *  adVisits: num,
 *  newAdUsers: num
 * }
 * @returns arrayOfObject, each object is a keyword data for all the available time, which is group by items that have the same keyword
 * {
 *  keywordValue: string
 *  visits: num, //sum all item has the keywordValue 
 *  newUsers: num, //sum all item has the keywordValue 
 *  adVisits: num, //sum all item has the keywordValue 
 *  newAdUsers: num //sum all item has the keywordValue
 * }
 */
export function groupDataByKeyword(data) {
    const groupedData = _.groupBy(data, 'keywordValue');
    return Object.entries(groupedData)
        .map(([key, value]) => ({
            keywordValue: key,
            ...sumData(value)
        }));
};
